import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Vehicle } from '@commons/models/domain/Vehicle';
import { findVehicleSpeedParamValue } from '@src/app/utils/params-binary-vehicle';

@Component({
  selector: 'app-calculate-speed',
  templateUrl: './calculate-speed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./calculate-speed.component.scss'],
})
export class CalculateSpeedComponent {
  
  @Input('data') set data(value: Vehicle) {
    this.calculate(value);
  }

  public value: number;
  public maxSpeed: number;

  constructor() { }

  private calculate(data: Vehicle): void {
    this.value = findVehicleSpeedParamValue(data);
    this.maxSpeed = data.LL?.SL || 9999;
  }

}
